module.exports = __webpack_public_path__ + "static/pattern-widget-sidepanel-d5b6318f4cd41b3fad3f4cdac309e135.png";